export function getPartyCompositionType(partyCompositionId: string) {
  const typesIds: Record<string, string> = {
    11: 'type_alone',
    12: 'type_withpartner',
    13: 'type_friends',
    14: 'type_family',
    15: 'type_singleparent',
    16: 'type_group',
  }
  const typeId = partyCompositionId in typesIds ? typesIds[partyCompositionId] : 'type_unknown'

  return typeId
}

export function stripHtmlTags(htmlString: string): string {
  if (!htmlString)
    return ''

  // Insert a space after every closing tag and <br> tags
  let text = htmlString
    .replace(/<\/[^>]+>/g, ' ')
    .replace(/<br\s*\/?>/gi, ' ')

  // Remove all remaining tags (including self-closing)
  text = text.replace(/<[^>]+>/g, '')

  // Collapse multiple spaces
  text = text.replace(/\s+/g, ' ').trim()

  // Remove space before punctuation
  text = text.replace(/\s+([.,!?:;])/g, '$1')

  return text
}
